import "@arco-design/web-react/es/Table/style";
import _Table from "@arco-design/web-react/es/Table";
import React from 'react';
import GuideLayout from '../GuideLayout';
import MermaidChart from '../MermaidChart';
import styles from '../style/index.module.less';
const statusChart = `stateDiagram-v2
    [*] --> 草稿 : 新建销售单
    草稿 --> 待审批 : 发布
    草稿 --> [*] : 删除
    待审批 --> 已批准 : 审批通过
    待审批 --> 已驳回 : 审批驳回
    已驳回 --> 待审批 : 修改后重新发布
    已批准 --> 已生效 : 系统自动派生计划\n（MRP 运算完成）
    已生效 --> 已生效 : 变更（新版本）`;
const statusColumns = [{
  title: '状态',
  dataIndex: 'status'
}, {
  title: '含义',
  dataIndex: 'meaning'
}, {
  title: '你能做什么',
  dataIndex: 'action'
}];
const statusData = [{
  status: '草稿',
  meaning: '刚创建，还没提交',
  action: '编辑、删除、发布'
}, {
  status: '待审批',
  meaning: '已提交，等审批人处理',
  action: '等待（可撤销）'
}, {
  status: '已驳回',
  meaning: '审批人退回',
  action: '修改后重新发布'
}, {
  status: '已批准',
  meaning: '审批通过',
  action: '系统自动触发 MRP 算料'
}, {
  status: '已生效',
  meaning: '已派生计划，进入执行',
  action: '变更（数量/交期调整）'
}];
const sections = [{
  id: 'prerequisite',
  label: '前提：先有客户信息'
}, {
  id: 'tips',
  label: '操作要点'
}, {
  id: 'status-flow',
  label: '销售单状态流转'
}, {
  id: 'delivery',
  label: '发货与退货'
}];
export default function Sales() {
  return /*#__PURE__*/React.createElement(GuideLayout, {
    title: "\u9500\u552E\u2014\u2014\u4ECE\u5BA2\u6237\u5230\u8BA2\u5355",
    firstQuestion: "\u6211\u8981\u5F55\u8BA2\u5355\uFF0C\u4F46\u4ECE\u54EA\u91CC\u5F00\u59CB\uFF1F",
    sections: sections
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['guide-section'],
    id: "prerequisite"
  }, /*#__PURE__*/React.createElement("h2", null, "\u524D\u63D0\uFF1A\u5148\u6709\u5BA2\u6237\u4FE1\u606F"), /*#__PURE__*/React.createElement("blockquote", null, "\u5F55\u5165\u9500\u552E\u5355\u7684\u524D\u63D0\u662F\u7CFB\u7EDF\u4E2D\u5DF2\u6709\u5BA2\u6237\u6863\u6848\u3002\u5982\u679C\u5BA2\u6237\u5217\u8868\u91CC\u627E\u4E0D\u5230\u4F60\u8981\u7684\u5BA2\u6237\uFF0C\u9700\u8981\u5148\u6DFB\u52A0\u3002"), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("strong", null, "\u64CD\u4F5C\u8DEF\u5F84\uFF1A"), "\u5BA2\u6237\u7BA1\u7406 \u2192 \u65B0\u589E\u5BA2\u6237 \u2192 \u586B\u5199\u5BA2\u6237\u540D\u79F0\u3001\u8054\u7CFB\u4EBA\u3001\u8054\u7CFB\u65B9\u5F0F \u2192 \u4FDD\u5B58")), /*#__PURE__*/React.createElement("div", {
    className: styles['guide-section'],
    id: "tips"
  }, /*#__PURE__*/React.createElement("h2", null, "\u64CD\u4F5C\u8981\u70B9"), /*#__PURE__*/React.createElement("div", {
    className: styles['guide-tips']
  }, /*#__PURE__*/React.createElement("ol", null, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("strong", null, "\u5148\u5EFA\u5BA2\u6237\u518D\u4E0B\u5355"), "\u2014\u2014\u6CA1\u6709\u5BA2\u6237\u6863\u6848\uFF0C\u9500\u552E\u5355\u65E0\u6CD5\u521B\u5EFA"), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("strong", null, "\u53D1\u5E03\u524D\u4ED4\u7EC6\u6838\u5BF9"), "\u2014\u2014\u53D1\u5E03\u540E\u8FDB\u5165\u5BA1\u6279\uFF0C\u9A73\u56DE\u624D\u80FD\u4FEE\u6539"), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("strong", null, "\u53D8\u66F4\u8D70\u53D8\u66F4\u5355"), "\u2014\u2014\u5DF2\u751F\u6548\u7684\u8BA2\u5355\u4E0D\u80FD\u76F4\u63A5\u6539\uFF0C\u8981\u8D70\u53D8\u66F4\u6D41\u7A0B\uFF0C\u7CFB\u7EDF\u53EA\u8C03\u6574\u53D7\u5F71\u54CD\u7684\u90E8\u5206"), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("strong", null, "\u5173\u6CE8\u5F85\u4EA4\u4ED8\u5217\u8868"), "\u2014\u2014\u8FD9\u91CC\u80FD\u770B\u5230\u6BCF\u7B14\u8BA2\u5355\u7684\u53D1\u8D27/\u9000\u8D27\u8FDB\u5EA6")))), /*#__PURE__*/React.createElement("div", {
    className: styles['guide-section'],
    id: "status-flow"
  }, /*#__PURE__*/React.createElement("h2", null, "\u9500\u552E\u5355\u72B6\u6001\u6D41\u8F6C"), /*#__PURE__*/React.createElement("div", {
    className: styles['guide-chart']
  }, /*#__PURE__*/React.createElement(MermaidChart, {
    chart: statusChart
  })), /*#__PURE__*/React.createElement("div", {
    className: styles['guide-table']
  }, /*#__PURE__*/React.createElement(_Table, {
    columns: statusColumns,
    data: statusData,
    pagination: false,
    size: "default",
    border: true
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles['guide-section'],
    id: "delivery"
  }, /*#__PURE__*/React.createElement("h2", null, "\u53D1\u8D27\u4E0E\u9000\u8D27"), /*#__PURE__*/React.createElement("blockquote", null, "\u8BA2\u5355\u6279\u51C6\u540E\uFF0C\u8FDB\u5165\u300C\u5F85\u4EA4\u4ED8\u300D\u5217\u8868\u3002\u4ED3\u5E93\u5B8C\u6210\u51FA\u5E93\u540E\uFF0C\u4F60\u53EF\u4EE5\u5728\u8FD9\u91CC\u770B\u5230\u53D1\u8D27\u8FDB\u5EA6\u3002"), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("strong", null, "\u53D1\u8D27\u6D41\u7A0B\uFF1A"), "\u4ED3\u5E93\u62E3\u6599\u51FA\u5E93 \u2192 \u7CFB\u7EDF\u8BB0\u5F55\u51FA\u5E93\u660E\u7EC6 \u2192 \u5F85\u4EA4\u4ED8\u6570\u91CF\u81EA\u52A8\u9012\u51CF"), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("strong", null, "\u9000\u8D27\u6D41\u7A0B\uFF1A"), "\u5BA2\u6237\u9000\u56DE \u2192 \u4ED3\u5E93\u6536\u8D27\u5165\u5E93 \u2192 \u9000\u8D27\u8BB0\u5F55\u5173\u8054\u539F\u51FA\u5E93\u5355")));
}